import React, { createContext, useState, useContext, useEffect } from "react";
import { useRouter } from "next/router";

const HistoryContext = createContext({});

export const HistoryProvider = ({ children }) => {
  const router = useRouter();
  const [history, setHistory] = useState([]);

  const back = (fallbackRoute) => {
    for (let i = history.length - 2; i >= 0; i--) {
      const route = history[i];

      if (!route.includes("#") && route !== router.pathname) {
        router.push(route);
        const newHistory = history.slice(0, i);
        setHistory(newHistory);
        return;
      }
    }
    if (fallbackRoute) {
      router.push(fallbackRoute);
    }
  };

  useEffect(() => {
    setHistory((previous) => [...previous, router.asPath]);
  }, [router.asPath]);

  return (
    <HistoryContext.Provider value={{ back, history, setHistory }}>
      {children}
    </HistoryContext.Provider>
  );
};

export const useCustomHistory = () => useContext(HistoryContext);
